export default __webpack_public_path__ + "static/media/ctg-8a.16e0a8fe.webp";